import { Backdrop, Box, ButtonGroup, Button as ButtonI, CircularProgress, Grid } from '@mui/material';
import InputForm from '../../../InputT';
import SearInputM from '../../../SearchModal';
import ParamsPicklist from '../../../../Types/ParamsPicklist';
import { ColumnsType } from 'antd/es/table';
import Table from '../../../TableResizable';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import EventIcon from '@mui/icons-material/Event';
import SweetAlert from "sweetalert2";
import { useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Utilisateur from '../../../../Models/Utilisateur';
import React, { useEffect, useState } from 'react';
import DataSelect from '../../../../Types/DataSelect';
import SelectOption from '../../../SelectOption';
import ExcelIcon from '../../../../Res/ExcelIcon.svg';
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import ReformatNumber from '../../../../Functions/Traitement/ReformatNumber';
import { Form, Input, Space } from 'antd';


let searchAgence: ParamsPicklist = { CodeAgence: "", Table: "AGENCE", Colonne1: "CODAGE", Colonne2: "LIBELLE", Colagence: "101", Choix: 22 }

const dataOption: DataSelect[] = [
  { label: "1--VERSEMENT", value: "1" },
  { label: "2--RETRAIT", value: "2" },
  { label: "3--ENVOI DE FOND", value: "3" },
  { label: "4--RECEPTION DE FOND", value: "4" },
  { label: "5--ALL", value: "5" }
]


const columns: ColumnsType<any> = [
  {
    title: 'Date Opération',
    dataIndex: 'DATOPE',
    ellipsis: true,
    width: 100,
  },
  {
    title: 'Libelle',
    dataIndex: 'LIBOPE',
    ellipsis: true,
    width: 200,
  },
  {
    title: 'Reférence auto',
    dataIndex: 'NUMSEQ',
    ellipsis: true,
    width: 100,
  },
  {
    title: 'Sens opération',
    dataIndex: 'SENSOP',
    ellipsis: true,
    width: 100,
  },
  {
    title: 'Montant',
    dataIndex: 'MONTAN',
    ellipsis: true,
    width: 100,
    align:"right"
  },
  {
    title: 'Compte',
    dataIndex: 'NUMCPT',
    ellipsis: true,
    width: 150,
  },
  {
    title: 'réferance manulle',
    dataIndex: 'NUMRAP',
    ellipsis: true,
    width: 100,
  },
  {
    title: 'Remettant',
    dataIndex: 'REMETT',
    ellipsis: true,
    width: 150,
  },
  {
    title: 'CNI Remettant',
    dataIndex: 'cniremet',
    ellipsis: true,
    width: 100,
  },
  {
    title: 'Type opération',
    dataIndex: 'TYPE',
    ellipsis: true,
    width: 100,
  },
  {
    title: 'Saisie par',
    dataIndex: 'UTISAI',
    ellipsis: true,
    width: 100,
  },
  {
    title: 'Validé par',
    dataIndex: 'UTIVAL',
    ellipsis: true,
    width: 100,
  }
];






const Tab1 = (props: { form?: any, data: any[] }) => {
  const [start, setstart] = useState(false);
  const [loading, setLoading] = useState(false);
  const [DataExcel, SetDataExcel] = useState<any[]>([]);
  const _exporter = React.createRef<ExcelExport>();

  // USER TOKEN
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };


  const handleExport = () => {
    setLoading(false);
  }


  useEffect(() => {
    if (start == false) {
      props.form.setFieldValue("DateFin", user.datjour);
      props.form.setFieldValue("DateDebut", user.datjour);
      setstart(true)
    }
  }, []);
  // USER SESSION
  const auth = useAuthUser();
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()));
  
  let searchCai: ParamsPicklist = { CodeAgence: props.form.getFieldValue("Agence"), Table: "CAI", Colonne1: "NODECE", Colonne2: "LECEON", Colagence: "AEGECE", Choix: 22 }


  const exportExcel = () => {
    if (props.data.length === 0) {
      SweetAlert.fire({ title: "Aucune donnée à exporter", icon: "warning" });
      return;
    }

    setLoading(true);

    const rows: any[] = props.data.map((data: any, indice: number) => ({
      key: indice,
      DATOPE: data.DATOPE || '',
      NUMSEQ: data.NUMSEQ,
      MONTAN: ReformatNumber(data.MONTAN || 0),
      NUMCPT: data.NUMCPT,
      NUMRAP: data.NUMRAP,
      LIBOPE: data.LIBOPE,
      REMETT: data.REMETT,
      cniremet: data.cniremet,
      TYPE: data.TYPE,
      UTISAI: data.UTISAI,
      UTIVAL: data.UTIVAL
    }));

    const totalMontant = rows.reduce((acc: number, cur: any) => acc + ReformatNumber(cur.MONTAN || 0), 0);

    rows.push({
      key: 'total',
      DATOPE: 'TOTAL',
      LIBOPE: 'TOTAL MONTANT',
      MONTAN: totalMontant
    });

    rows.push({
      key: 'count',
      DATOPE: 'NB',
      LIBOPE: `${props.data.length} opération(s)`,
      MONTAN: props.data.length
    });

    SetDataExcel(rows);

    if (!_exporter.current) {
      setLoading(false);
      return;
    }

    setTimeout(() => {
      _exporter.current?.save();
    }, 0);
  };



  return (
    <div className='tabItem'>
       <Box fontStyle={"inherit"}   className='bordure1'  position={"absolute"} style={{ width: '85%' }}>
              
           <Box  fontStyle={"inherit"}   className='bordure1'  style={{ display: 'flex' }}>
              <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={4} lg={4}>
                   <SearInputM  defaultCode={user.codage}   defaultLibelle={user.agence} disabled={true}  Titre={"Recherche D'agence"} label={"Agence"} name={"Agence"} Parametre={searchAgence} form={props.form} />
                   </Grid>
                   <Grid item xs={12} sm={12} md={4} lg={4}>
                   <SelectOption Size={'middle'}  disabled={false}  label={"Caisse"} name={"NODECE"} Parametre={searchCai} />
                   </Grid>
                   <Grid item xs={12} sm={12} md={4} lg={4}>
                  <SelectOption  Option={dataOption}  label="Opération" Size={'middle'} name="TypeOpe" />
                  </Grid>
                </Grid>
               </Box>

               <Box  fontStyle={"inherit"}   className='bordure1' >
               <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={4} lg={4}>
                  <InputForm icon={<EventIcon color='success' />} label={" Date Debut"} name={"DateDebut"} type='date' />
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                  <InputForm icon={<EventBusyIcon color='info' />} label={"Date Fin"} name={'DateFin'} type='date' />
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                  <ButtonGroup disableElevation color='success' variant="outlined" aria-label="Disabled elevation buttons">
                    <ButtonI disabled={props.data.length >= 1 ? false : true} onClick={exportExcel}>
                      <img  src={ExcelIcon}></img> </ButtonI>
                  </ButtonGroup>
                        </Grid>
                </Grid>
            </Box>

            <Box fontStyle="inherit" className='bordure1' >
             <Table pagination={false} size='small' style={{ width: 'auto' }} columns={columns} dataSource={props.data} scroll={{ y: 320, x: 1200 }} />
            </Box>

            <Box display={"flex"} width={"98%"} marginTop={"2%"} fontStyle="inherit" className='bordure1'>
              <Space.Compact style={{ marginLeft: '5%' }} size="middle" >
                <Form.Item style={{ width: '70%' }} label="Total Crédit / Nombre crédit" name='TotalCrebit'><Input disabled /></Form.Item>
                <Form.Item style={{ width: '14%' }} name='NbrCrebit'><Input disabled /></Form.Item>
              </Space.Compact>
              <Space.Compact style={{ marginLeft: '5%' }} size="middle" >
                <Form.Item style={{ width: '70%' }} label="Total Débit / Nombre débit" name='TotalDebit'><Input disabled /></Form.Item>
                <Form.Item style={{ width: '14%' }} name='Nbrdebit'><Input disabled /></Form.Item>
              </Space.Compact>
            </Box>

       </Box>
     
               {/* <Box style={{ display: 'flex' }}>
            <Box width={'35%'}>
              <SearInputM defaultCode={user.codage} defaultLibelle={user.agence} disabled={false} width={4} Titre={"Recherche D'agence"} label={"Agence"} name={"Agence"} Parametre={searchAgence} form={props.form} />
            </Box>
            <Box width={'35%'}>
              <SelectOption Size={'middle'} disabled={false} width={4} label={"Caisse"} name={"NODECE"} Parametre={searchCai} />
            </Box>
            <Box width={'40%'}>
              <SelectOption Option={dataOption} width={6} label="Opération" Size={'middle'} name="TypeOpe" />
            </Box>

          </Box> */}
          {/* <Box style={{ display: 'flex' }}>
            <InputForm icon={<EventIcon color='success' />} label={" Date Debut"} name={"DateDebut"} type='date' />
            <InputForm icon={<EventBusyIcon color='info' />} label={"Date Fin"} name={'DateFin'} type='date' />
            <ButtonGroup disableElevation color='success' variant="outlined" aria-label="Disabled elevation buttons">
              <ButtonI disabled={props.data.length >= 1 ? false : true}
                onClick={exportExcel}
              >
                <img style={{ width: 25 }} src={ExcelIcon}></img> </ButtonI>
            </ButtonGroup>
          </Box> */}
          

            
     
      <ExcelExport filterable={true} data={DataExcel} fileName="AnyListingCaisse.xlsx" ref={_exporter} onExportComplete={handleExport}>
        <ExcelExportColumn field="DATOPE" title="Date Opération" locked={true} width={200} />
        <ExcelExportColumn field="NUMSEQ" title="Reference" locked={true} />
        <ExcelExportColumn field="LIBOPE" title="Libelle" />
        <ExcelExportColumn field="MONTAN" title="Monatant" />
        <ExcelExportColumn field="NUMCPT" title="NUMCPT" />
        <ExcelExportColumn field="NUMRAP" title="NUMRAP" />
        <ExcelExportColumn field="REMETT" title="REMETTANT" />
        <ExcelExportColumn field="TYPE" title="TYPE" />
        <ExcelExportColumn field="UTISAI" title="UTISAI" />
        <ExcelExportColumn field="UTIVAL" title="UTIVAL" />
      </ExcelExport>

      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading} >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>

  );

}

export default Tab1;